module.exports = __webpack_public_path__ + "img/pm10.fc847f68.png";